import '../components/quantity-selector.js';
import renderSectionFromResponse from '../utils/render-section-from-response.js';
import updateBagCount from '../utils/update-bag-count.js';
import dispatchEvent from '../utils/dispatch-event.js';

class CartPage extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:quantity-updated', () =>
      this.updateCartSection()
    );
    document.addEventListener('cart:gift-upsell-item:added', () =>
      setTimeout(() => this.updateCartSection(), 2500)
    );
    document.addEventListener('cart:gift-upsell-item:removed', () =>
      setTimeout(() => this.updateCartSection(), 1000)
    );
    document.addEventListener('cart:free-gift:added', () =>
      setTimeout(() => this.updateCartSection(), 500)
    );

    // [...document.querySelectorAll('[data-cart-item]')].forEach(lineItem => {
    //   fetch('/cart/change.js', {
    //     credentials: 'same-origin',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-Requested-With': 'XMLHttpRequest',
    //     },
    //     method: 'POST',
    //     body: JSON.stringify({
    //       line: lineItem.dataset.lineIndex,
    //       quantity: lineItem.dataset.quantity,
    //       properties: {
    //         ...Object.fromEntries(
    //           JSON.parse(lineItem.dataset.currentProperties)
    //         ),
    //       },
    //     }),
    //   }).then(() => {
    //     dispatchEvent('cart:properties-updated', document);
    //   });
    // });
  }

  updateCartSection() {
    fetch(`/cart?sections=${this.dataset.section}`)
      .then(response => response.json())
      .then(response => {
        renderSectionFromResponse(
          '[data-cart-page]',
          this.dataset.section,
          response
        );
        updateBagCount();

        setTimeout(() => {
          dispatchEvent('cart:rerendered', document);
        }, 500);
      });
  }

  // eslint-disable-next-line class-methods-use-this
  initTermsCheckbox() {
    const checkoutButton = document.querySelector('[data-checkout-button]');
    const termsCheckbox = document.querySelector('[data-terms]');

    termsCheckbox.addEventListener('change', () => {
      checkoutButton.classList.toggle(
        'btn-disabled',
        termsCheckbox.checked === false
      );
    });
  }
}

customElements.define('cart-page', CartPage);
